<fieldset bsMigration [bs3Class]="['panel-default']" [bs4Class]="['mb-3']" formGroupName="individual" class="panel" [disabled]="isSaving">
  <legend bsMigration class="panel-heading">Personal Information</legend>
  <div bsMigration class="panel-body">
    <div [bs4Class]="['mb-2']" class="form-group">
      <label for="input-name-first">First Name</label>
      <input type="text" class="form-control" id="input-name-first" formControlName="ind_first_name" required placeholder="first name" [readonly]="existing" [appCopyValue]="ind_badge_name">
    </div>
    <div [bs4Class]="['mb-2']" class="form-group">
      <label for="input-name-middle">Middle Name</label>
      <input type="text" class="form-control" id="input-name-middle" formControlName="ind_mid_name" placeholder="middle name" [readonly]="existing">
    </div>
    <div class="form-group">
      <label for="input-name-last">Last Name</label>
      <input type="text" class="form-control" id="input-name-last" formControlName="ind_last_name" required placeholder="last name" [readonly]="existing">
    </div>
    <hr/>
    <div class="form-group">
      <label for="input-name-badge">Preferred Name</label>
      <input type="text" class="form-control" id="input-name-badge" formControlName="ind_badge_name" required placeholder="preferred name">
      <p [bs4Class]="['my-0']" class="help-text">If not your first name, what you would like to be called in emails and phone calls.</p>
    </div>
  </div>
</fieldset>
